<template>

  <div id="agency">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- agency -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">                    
                <div class="row">
                  <div class="col-12 d-flex align-items-center flex-column">
                    <h1 class="c-h1">Wenn ihr euch fragt, wie ihr mehr Glück bei der Arbeit in eure Agentur bringt - dann seid ihr hier richtig.</h1> 
                    <!--
                    <p class="c-txt-orange" style="font-weight: bold;">Profitiere von unserem Know-How</p>     
                    --> 
                  </div>
                  <div class="col-12 py-3 col-md-8 d-flex align-items-center justify-content-center">             
                    <p class="text-center text-md-left">
                        Der Agency Happiness Report zeigt: Genau hier liegt oft noch Potenzial.
                        Und gleichzeitig ist gar nicht immer klar, wo man eigentlich anfangen soll.
                        Die gute Nachricht: Ihr müsst das Thema nicht kompliziert machen. Es gibt einfache Wege, um loszulegen.
                    </p>             
                    <img id="bubble_academy_1" src="@/assets/bubble_red_1.png" alt="bubble">  
                  </div>

                  <!-- button -->
                  <div class="col-12 d-flex">
                    <a :href="`mailto:office@felicicon.com?subject=${emailSubject}&body=${emailBody}`">
                      <div class="c-btn c-btn-orange" >
                        <img src="@/assets/bootstrap_icons/envelope-at-fill.svg" style="width: 18px; filter: invert(100%); margin-left: 8px;">
                        <span style="padding: 10px">Email Kontakt</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </a>
                  </div>
                  <!-- button -->
                  <div class="col-12 d-flex">
                    <a :href="`tel:+493078714337`">
                      <div class="c-btn c-btn-orange" >
                        <img src="@/assets/bootstrap_icons/telephone-fill.svg" style="width: 18px; filter: invert(100%); margin-left: 8px;">
                        <span style="padding: 10px">+49 30 78714337</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </a>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- 2 column layout  -->
    <div class="container-xl">
      <div class="row justify-content-center">
        <div class="col-11 col-md-10 pb-5">   
          <div class="row align-items-start">

            <!-- formate -->
            <div class="col-12 order-1 col-lg-7 text-center justify-content-center text-lg-left justify-content-lg-left">
              <div class="row">
                <div class="col-12">
                  <h2 class="c-h2 c-txt-orange">Einfach anfangen ...</h2>
                </div>  
                <div class="col-12">
                  <img src="@/assets/academy_team_dev-sm.png" alt="Formates" style="margin: 20px; width: 95%;  max-width: 280px;">
                </div>  
              </div>
              <!-- happiness hacks -->
              <div class="row pb-4">
                <div class="col-12">
                  <h2 class="c-h2 c-txt-blue">Happiness Hacks</h2>
                </div>
                <div class="col-12 col-md-7">
                  Kurze, lebendige Impulse, die sich perfekt in den Arbeitsalltag integrieren lassen - z. B. als Mittagspausen-Format mit direktem Aha-Effekt.
                </div>
                <div class="col-12 col-md-5">
                  <div class="d-flex justify-content-center">  
                    <!-- button -->
                    <router-link to="/academy/happiness_hacks" style="text-decoration: none">
                      <div class="c-btn c-btn-orange">
                        <span style="padding: 5px">Mehr Infos</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </router-link>
                  </div>
                </div> 
              </div>
              <!-- HAW Workshops --> 
              <div class="row pb-4">
                <div class="col-12">
                  <h2 class="c-h2 c-txt-blue">Glück bei der Arbeit - Workshop</h2>
                </div>
                <div class="col-12 col-md-7">
                  Ein Workshop für Teams, die sich intensiver mit dem Thema beschäftigen und konkrete Ansätze für ihren Arbeitsalltag entwickeln wollen.
                </div>
                <div class="col-12 col-md-5">
                  <div class="d-flex justify-content-center">  
                    <!-- button -->
                    <router-link to="/academy/happiness_and_work" style="text-decoration: none">
                      <div class="c-btn c-btn-orange">
                        <span style="padding: 5px">Mehr Infos</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
              <!-- positive leadership --> 
              <div class="row pb-4">
                <div class="col-12">
                  <h2 class="c-h2 c-txt-blue">Positive Leadership</h2>
                </div>
                <div class="col-12 col-md-7">
                  Programme für Führungskräfte, die lernen wollen, wie sie Rahmenbedingungen schaffen, in denen Glück bei der Arbeit überhaupt entstehen kann.
                </div>
                <div class="col-12 col-md-5">
                  <div class="d-flex justify-content-center">  
                    <!-- button -->
                    <router-link to="/academy/positive_leadership" style="text-decoration: none">
                      <div class="c-btn c-btn-orange">
                        <span style="padding: 5px">Mehr Infos</span>
                        <div class="c-btn-img c-btn-img-right-white"/>
                      </div>
                    </router-link>
                  </div>
                </div> 
              </div>
            </div>

            <!-- über mich -->
            <div class="col-12 order-2 col-lg-5 text-center justify-content-center text-lg-right justify-content-lg-right">
              <div class="row">
                <div class="col-12">
                  <h2 class="c-h2 c-txt-orange">Über mich ...</h2>
                </div>
                <div class="col-12">
                  Hallo, ich bin Ricarda, Professorin für Psychologie und Expertin für Glück bei der Arbeit.
                  In meiner Forschung beschäftige ich mich damit, wie Glück bei der Arbeit entsteht, wie man es messbar machen kann - und vor allem, wie wir die vielen wissenschaftlichen Erkenntnisse endlich in den Arbeitsalltag bringen.
                  Denn genau da liegt das Problem: Wir wissen unglaublich viel, aber in Unternehmen kommt davon oft viel zu wenig an.
                  Deshalb übersetze ich Forschung in praxistaugliche Ansätze - verständlich, umsetzbar und in einer Sprache, die auch außerhalb von Fachartikeln funktioniert.
                  Mit der Happiness & Work Academy bringe ich diese Inhalte in Formate für Teams und Führungskräfte. Ich begleite Organisationen zusätzlich beratend dabei, die für sie wirksamen Hebel zu identifizieren und gezielt umzusetzen.
                </div>
              </div>
              <div class="col-12">
                <img src="@/assets/academy_bubble_keynotes.png" alt="HappinessAndWork_Keynotes" style="margin: 20px; width: 95%;  max-width: 280px;">
              </div>  
              <div class="col-12">
                Wenn ihr tiefer einsteigen oder herausfinden wollt, was bei euch wirklich wirkt, meldet euch gern direkt.
              </div>
              <!-- button -->
              <div class="col-12 d-flex justify-content-center justify-content-lg-end">
                <a :href="`mailto:office@felicicon.com?subject=${emailSubject}&body=${emailBody}`">
                  <div class="c-btn c-btn-orange" >
                    <img src="@/assets/bootstrap_icons/envelope-at-fill.svg" style="width: 18px; filter: invert(100%); margin-left: 8px;">
                    <span style="padding: 10px">Email Kontakt</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </a>
              </div>
              <!-- button -->
              <div class="col-12 d-flex justify-content-center justify-content-lg-end">
                <a :href="`tel:+493078714337`">
                  <div class="c-btn c-btn-orange" >
                    <img src="@/assets/bootstrap_icons/telephone-fill.svg" style="width: 18px; filter: invert(100%); margin-left: 8px;">
                    <span style="padding: 10px">+49 30 78714337</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </a>
              </div>
            </div>           
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Academy',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // email data
      emailSubject: "HAW Anfrage - Agency",
      emailBody: "Guten Tag,%0A%0Aich bin auf der Website www.happinessandwork.de auf euer Angebot aufmerksam geworden.%0AIch würde gern diesbezüglich kontaktiert werden - Tel: [meine_telefonnummer]%0A%0AVielen Dank",

      // metaData
      metaTitle: "- Agency - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/agency",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png"
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // Create render evnt puppeteer is waiting for when prerender pager (see param: renderAfterDocumentEvent)
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
  }
}

</script>

<style>
</style>
